import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import * as React from "react";
import { TwoColumnsGridData, TwoColumnsGrid } from "../TwoColumnsGrid";

export interface RaceOrderProps {
  order: any;
}

export default (props: RaceOrderProps) => {
  // return <div>{JSON.stringify(props, null, 2)}</div>
  const { order } = props;
  console.log("Datos de la orden", order);

  const colunms: TwoColumnsGridData[] = [
    { type: "title", label: "Orden" },
    { type: "divider" },
  ];

  const orderDataItem = order[0].orderItem;
  const { amount, invoice, paymentMethod, priceDelivery, total } =
    orderDataItem;

  return (
    <div>
      <TwoColumnsGrid data={colunms} />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Producto</TableCell>
            <TableCell numeric>Cantidad</TableCell>
            <TableCell numeric>Sub-Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {order.map((d: any) => {
            return (
              <TableRow key={d.id}>
                <TableCell component="th" scope="row">
                  {d.product.name}
                </TableCell>
                <TableCell numeric>{d.quantity}</TableCell>
                <TableCell numeric>{d.priceSubTotal}</TableCell>
              </TableRow>
            );
          })}
          <TableRow>
            <TableCell>Costo de envío</TableCell>
            <TableCell />
            <TableCell numeric>Gs. {priceDelivery}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Table>
        <TableHead>
          <TableRow style={{ backgroundColor: "#c62828" }}>
            <TableCell style={{ color: "white" }}>Total</TableCell>
            <TableCell style={{ color: "white" }} numeric>
              Gs. {total}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Forma de Pago</TableCell>
            <TableCell numeric> {paymentMethod}</TableCell>
          </TableRow>
          {paymentMethod === "EFECTIVO" && (
            <>
              <TableRow>
                <TableCell>Efectivo del cliente</TableCell>
                <TableCell numeric>Gs. {amount}</TableCell>
              </TableRow>
              {amount !== null && (
                <TableRow>
                  <TableCell>Vuelto</TableCell>
                  <TableCell numeric>Gs. {amount - total}</TableCell>
                </TableRow>
              )}
            </>
          )}
          <TableRow>
            <TableCell>Preparar factura</TableCell>
            <TableCell numeric> {invoice ? "SI" : "NO"}</TableCell>
          </TableRow>
        </TableHead>
      </Table>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/race/RaceDeliveryComponent.tsx